import BrandLogo from "@/components/BrandLogo";

export default function StorefrontHero() {
  return (
    <div className="flex flex-col items-center justify-center pt-20 pb-16 px-4 text-center">
      <BrandLogo
        alt="Institute logo"
        className="h-20 md:h-28 w-auto mb-8 object-contain drop-shadow-sm"
      />
      <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-foreground mb-4">
        Professional Certification Programs
      </h1>
      <p className="text-muted-foreground text-lg max-w-xl mx-auto font-medium">
        Explore the exact learning journey and enroll through our secure learner checkout powered by Razorpay.
      </p>
    </div>
  );
}
